module.exports = __webpack_public_path__ + "assets/boy_2x.751d3f46c873305fa62d74125979a67df8b94f2ccb7e4ba816d2271a5d2d5361.png";